'use strict';

module.exports = function contains(key, value) {
  return !this.contains(key, value);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/doesntContain.js
// module id = 1648
// module chunks = 2